import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { withStyles } from "@mui/styles";

const styles = (/* theme */) => ({
  menu: {
    width: 200
  }
});

class Strategy extends React.Component {

  getStrategies = () => {
    const { strategies, value } = this.props;
    if (isEmpty(strategies)) {
      return [{ id: 0, name: 'No strategies available'}];
    }
    // Remove soft-deleted strategies except one that the placement already has
    return strategies.filter(s => !s.deletedAt || s.id === value);
  };

  render() {
    const { classes, value, disabled } = this.props;
    const strategies = this.getStrategies();

    return (
      <TextField
        variant="standard"
        fullWidth
        select
        disabled={disabled}
        name="StrategyId"
        margin="normal"
        label="Strategy"
        value={value}
        onChange={this.props.onChange}
        SelectProps={{
          MenuProps: {
            className: classes.menu
          }
        }}>
        {strategies.map(strat => (
          <MenuItem key={strat.name} value={strat.id}>
            {strat.name}
          </MenuItem>
        ))}
      </TextField>
    );
  }
}

Strategy.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  strategies: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default  withStyles(styles)(Strategy);
